module.exports = __webpack_public_path__ + "static/scale-model-of-the-rainbow-bridge-in-long-beach-california-d85ec99577c638a27c414c2ab9b85945.png";